import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=5307ec46&scoped=true"
import script from "./notes.vue?vue&type=script&lang=js"
export * from "./notes.vue?vue&type=script&lang=js"
import style0 from "./notes.vue?vue&type=style&index=0&id=5307ec46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5307ec46",
  null
  
)

export default component.exports